import { Routes } from '@angular/router';
import { AppRoute, AppRouteParam } from './app.route';
import { authenticationGuard } from './core/authentication/authentication.guard';
import { cultureResolver } from './core/culture/culture.resolver';
import { businessUnitGuard } from './features/business.guard';
import { verifyParamsGuard } from './features/login/login-params.guard';

export default [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AppRoute.PageNotFound,
  },

  {
    path: AppRoute.PullRequest,
    redirectTo: AppRoute.PageNotFound,
  },

  {
    path: AppRoute.PageNotFound,
    loadComponent: () => import('./features/page-not-found/page-not-found.component'),
  },

  {
    path: `:${AppRouteParam.BusinessUnit}`,
    resolve: {
      _: cultureResolver,
    },
    canActivate: [businessUnitGuard()],
    children: [
      {
        path: AppRoute.Share,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: AppRoute.Login,
          },
          {
            path: AppRoute.Login,
            loadChildren: () => import('./features/login/login.routes'),
            canActivate: [verifyParamsGuard],
          },
          {
            path: AppRoute.Documents,
            canActivate: [authenticationGuard],
            loadChildren: () => import('./features/documents/document.routes'),
          },
        ],
      },
    ],
  },

  { path: '**', redirectTo: AppRoute.PageNotFound }, // Must be last route
] as Routes;
